import { PieChartIcon } from 'de-suite-me-ui'

export default PieChartIcon
